export default __webpack_public_path__ + "static/media/razorpaysleek.8fc98869efcd48dc3e6f946ced8495a5.webp";